import { theme } from "../../theme";
import { useResponsive as useResponsiveBase } from "@clearabee/ui-library-base";
import { useWindowDimensions } from "react-native";
export const useResponsive = () => {
    const { width } = useWindowDimensions();
    return useResponsiveBase(width, theme.screens);
};
//# sourceMappingURL=useResponsive.js.map